'use strict';

angular.module('page.tag.services', [])
    .factory('PageTagFactory', PageTagFactory);

/**
 * @ngInject
 */
function PageTagFactory(
    PageTagsResource
) {
    var tags = [];

    return {
        getTags: getTags,
        setTags: setTags,
        saveTags: saveTags
    };

    /**
     * Return list of tags available to pages
     * @returns {*}
     */
    function getTags() {
        return PageTagsResource.getData();
    }

    function setTags(newtags) {
        if (_.isArray(newtags)) {
            tags = newtags;
        }
        else {
            console.error('Error: Trying to set page tags as a non array');
        }
    }

    /**
     * Save list of new tags
     * @param payload
     * @returns {Promise<Data>}
     */
    function saveTags(payload) {
        return PageTagsResource.save(payload).then(function () {
            return PageTagsResource.getData();
        }).then(function (data) {
            setTags(data);
        });
    }
}